import { AppConfig } from '../appConfig';

const configPrd: AppConfig = {
  rootPath: '',
  apiGateway: {
    region: 'ap-northeast-1',
    endpoint: `https://98xespcnz9.execute-api.ap-northeast-1.amazonaws.com/prd`,
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: {
      staticContents: {
        endpoint: `https://d367whr2asz6yw.cloudfront.net`,
      },
    },
  },
  ga4: {
    trackingId: 'G-9D9LP5XF4P',
  },
};

export default configPrd;
